<template>
  <div class="bg-white">
    <v-container fluid class="page__container--padding">
      <search-customer-seller :show-goback="false" />
      <div class="d-flex my-4">
        <div class="w-auto d-inline-flex align-center mr-4">
          Indicadores:
          <custom-select
            v-model="filters.metric"
            :disabled="loadingCustomerStats"
            :options="metrics"
          />
        </div>
        <div class="w-auto d-inline-flex align-center mr-4">
          Canal:
          <custom-select
            v-model="filters.channel"
            :disabled="loadingCustomerStats"
            :options="channels"
          />
        </div>
        <div
          v-if="filters.territory"
          class="w-auto d-inline-flex align-center mr-4"
        >
          Territorio:
          <custom-select
            v-model="filters.territory"
            :disabled="loadingCustomerStats"
            :options="territories"
          />
        </div>
        <div
          v-if="filters.manager"
          class="w-auto d-inline-flex align-center mr-4"
        >
          G.Estatal:
          <custom-select
            v-model="filters.manager"
            :disabled="loadingCustomerStats"
            :options="managers"
          />
        </div>
      </div>
      <h3>{{ metricSelcted.label }}</h3>
      <billing-table
        v-if="showBillingTable"
        :loading="loadingCustomerStats"
        :items="customerStats"
        :column-title="columnTitle"
        :metric="filters.metric"
        @optionSelected="updateFilters"
      />
      <customers-table
        v-else
        :items="customerStats"
        :loading="loadingCustomerStats"
        :column-title="columnTitle"
        :metric="filters.metric"
        @optionSelected="updateFilters"
      />

      <alert-prominent
        v-if="error"
        indeterminate
        :message="error"
        :disabled-button="loadingCustomerStats"
      />
      <div
        v-if="lastUpdate"
        class="text-caption text-left font-weight-bold mt-4"
      >
        Última actualización {{ lastUpdate }}
      </div>
    </v-container>
  </div>
</template>
<script>
  import SearchCustomerSeller from '@/components/SearchCustomerSeller.vue';
  import CustomSelect from '@/components/CustomSelect.vue';
  import CustomersTable from './components/CustomersTable.vue';
  import BillingTable from './components/BillingTable.vue';
  import AlertProminent from '@/components/AlertProminent.vue';

  import numbersFormats from '@/mixins/numbersFormats';
  import axios from '@/plugins/axios';

  export default {
    name: 'ProjectManager',
    components: {
      SearchCustomerSeller,
      CustomSelect,
      CustomersTable,
      BillingTable,
      AlertProminent,
    },
    mixins: [numbersFormats],
    data: () => ({
      filters: {
        metric: 'geolocation',
        channel: 'PR',
        territory: null,
        manager: null,
      },
      optionSelected: [],
      showBillingTable: false,
      metrics: [
        {
          value: 'geolocation',
          label: 'Geolocalización',
        },
        { value: 'photos', label: 'Fotos' },
        { value: 'contacts', label: 'Datos de contacto' },
        { value: 'IELBillingAmount', label: 'Facturación IEL' },
        { value: 'IELBillingCustomers', label: 'Facturación cliente' },
        { value: 'customersWithIEL', label: 'Clientes con pagos IEL' },
        { value: 'IELPaymentAmount', label: 'Pagos IEL importe' },
      ],
      loadingTerritories: false,
      channels: [
        { value: 'DT', label: 'Mostradores' },
        { value: 'PR', label: 'Distribuidores' },
      ],
      territories: [],
      managers: [],
      customerStats: [],
      loadingCustomerStats: true,
      columnTitle: 'Territorios',
      error: null,
      lastUpdate: null,
    }),
    computed: {
      metricSelcted() {
        return this.metrics.find(
          (metric) => metric.value === this.filters.metric
        );
      },
    },
    watch: {
      'filters.metric': function (metric) {
        this.showBillingTable = [
          'IELBillingAmount',
          'IELPaymentAmount',
        ].includes(metric);
      },
      'filters.channel': function () {
        this.filters.manager = null;
        this.filters.territory = null;
        this.getCustomerStats();
      },
      'filters.territory': function (value) {
        this.filters.manager = null;
        if (value) {
          this.getCustomerStats();
          this.columnTitle = 'Gerentes estatales';
        }
      },
      'filters.manager': function (value) {
        if (value) {
          this.getCustomerStats();
          this.columnTitle = 'Zonas';
        }
      },
    },
    mounted() {
      this.getCustomerStats();
      this.loadTerritories();
    },
    methods: {
      updateFilters(selection) {
        if (selection.territorial_director_id) {
          this.filters.territory = selection.value;
        }
        if (selection.state_manager_id) {
          this.filters.manager = selection.value;
          this.loadManagers();
        }
      },
      async getCustomerStats() {
        try {
          this.loadingCustomerStats = true;
          const response = await axios.post(
            '/project-manager/customer-stats',
            this.filters
          );
          this.customerStats = response.data;
          this.lastUpdate = response.data.lastUpdate;
        } catch (error) {
          this.error = error.response.data.message;
        }
        this.loadingCustomerStats = false;
      },
      async loadTerritories() {
        this.error = '';
        try {
          this.loadingTerritories = true;
          const response = await axios.post(
            '/project-manager/territories',
            this.filters
          );
          this.territories = response.data;
        } catch (error) {
          this.error = error.response.data.message;
        }
        this.loadingTerritories = false;
      },
      async loadManagers() {
        try {
          const response = await axios.post(
            '/project-manager/managers',
            this.filters
          );
          this.managers = response.data;
        } catch (error) {
          this.error = error.response.data.message;
        }
      },
    },
  };
</script>
